import { render, staticRenderFns } from "./ListFiltroModalItemInputCliente.vue?vue&type=template&id=120243e1"
import script from "./ListFiltroModalItemInputCliente.vue?vue&type=script&lang=js"
export * from "./ListFiltroModalItemInputCliente.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports